import { createModuleContext } from '@rebuild/utils/moduleContext';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import { useModuleConfig } from '@rebuild/hooks/data/useModuleConfig';
import { ref } from 'vue';

const MODULE_NAME = 'corporate_governance';

function buildBaseCtx() {
	return {
		useSlideMStyle: false,
		currentModuleId: MODULE_NAME
	};
}

const useCurrentReactive = () => {
	const { corporate_governance, corporate_governance_custom } = useModuleData();
	const { config, loadModuleConfig } = useModuleConfig();

	// 状态管理
	const departmentList = ref([]);
	const moduleGroups = ref([]);
	const selectedDepartmentValue = ref();
	const selectedMemberInfo = ref({});
	const displayConfig = ref({});

	// 数据处理
	const processCorporateData = () => {
		const result = corporate_governance.data?.data || [];
		let departments = [];

		displayConfig.value.displayDepartment
			.filter(item => item.isSelected)
			.forEach(item => {
				const { value, sort, name, isImage } = item;
				if (value === 0) {
					// 全部人员，平铺展示
					departments.push({
						members: result,
						sort,
						name,
						selected: 'all',
						showAvatar: isImage
					});
				} else {
					const filteredMembers = result.filter(v => v.type.split(',').includes(value.toString()));
					departments.push({
						members: filteredMembers || [],
						sort,
						value,
						name,
						selected: value,
						showAvatar: isImage
					});
				}
			});
		departments = departments.sort((a, b) => a.sort - b.sort);

		departmentList.value = departments;
		moduleGroups.value = departments.map(v => {
			return {
				label: v.name,
				value: v.selected
			};
		});
		selectedDepartmentValue.value = moduleGroups.value?.[0]?.value;
		selectedMemberInfo.value = departmentList.value?.[0];
	};

	const changeModule = ({ value, index }) => {
		selectedDepartmentValue.value = value;
		selectedMemberInfo.value = departmentList.value[index];
	};

	

	return {
		corporate_governance,
		corporate_governance_custom,
		moduleGroups,
		selectedDepartmentValue,
		selectedMemberInfo,
		displayConfig,
		config, 
		processCorporateData,
		changeModule,
		loadModuleConfig
	}
}

const { provide: provideCurrentContext, use: useCurrentContext } = createModuleContext(MODULE_NAME, buildBaseCtx);

export { provideCurrentContext, useCurrentContext, useCurrentReactive };
